import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/assetAssociatedInventoryReport'
import Component from 'components/Reports/AssetAssociatedInventoryReport'

export default createListViewContainer({ actions, selectors: selectors.assetAssociatedInventoryReport })(
  Component
)
